// extracted by mini-css-extract-plugin
module.exports = {"description":"RolesTable_description__PgISB"};